import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91201442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = ["onClick"]

import { onMounted, ref, watch } from 'vue'
import { devicePage, deviceOnlinecheck } from '@/api'
import { get } from 'lodash'
import { CODE_ENUM, DEVICE_STATUS_ENUM, PAGE_SIZES } from '@/common'
import { useProductStore } from '@/stores/product'
import { useDeviceStore } from '@/stores/device'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import i18n from '@/i18n'
import OperationButtonList from '@/components/operation-button-list'
import moment from 'moment'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'site-device-table',
  props: ['siteId', 'deviceStatusCode'],
  setup(__props) {

const props = __props;



watch(
  () => props.siteId,
  () => {
    if (props.deviceStatusCode) {
      formInline.value.deviceStatusCode = props.deviceStatusCode
    }
    advancedRef.value.fetchList()
  }
)

const t = i18n.global.t

const router = useRouter()

const advancedRef = ref()

const buttonList = ref([
  {
    type: 'detail',
    text: t('D_INFO.btnDetail'),
  },
])

const deviceStatusOps = [
  {
    label: t('D_INFO.labelNoactive'),
    value: DEVICE_STATUS_ENUM.NOACTIVATE,
  },
  //   {
  //     label: t('D_INFO.labelActive'),
  //     value: DEVICE_STATUS_ENUM.INACTIVATE,
  //   },
  {
    label: t('D_INFO.labelOffline'),
    value: DEVICE_STATUS_ENUM.OFFLINE,
  },
  {
    label: t('D_INFO.labelOnline'),
    value: DEVICE_STATUS_ENUM.ONLINE,
  },
]

const deviceStatusMap = {
  [DEVICE_STATUS_ENUM.ONLINE]: 'success',
  [DEVICE_STATUS_ENUM.INACTIVATE]: '',
  [DEVICE_STATUS_ENUM.OFFLINE]: 'info',
  [DEVICE_STATUS_ENUM.NOACTIVATE]: 'warning',
}
const getDeviceTagType = (status: any) => {
  return deviceStatusMap[status]
}

const productStore = useProductStore()
productStore.queryGetewayType()

const $route = useRoute()
const siteId = $route.query.id || ''
const deviceStore = useDeviceStore()
deviceStore.queryDeviceOps({
  siteId: Number(siteId),
})

const columns = [
  {
    prop: 'deviceName',
    label: t('D_INFO.colName'),
  },
  {
    prop: 'deviceSn',
    label: t('D_INFO.colSn'),
  },
  {
    prop: 'orgName',
    label: t('D_INFO.colOrg'),
  },
  {
    prop: 'productTypeValue',
    label: t('D_INFO.colProduct'),
  },
]

const tableData: any = ref([])
const formInline = ref({
  deviceId: '',
  deviceSn: '',
  productKey: '',
  deviceStatusCode: '',
})

// const $route = useRoute()
// const deviceStatusCode: any = $route.query.deviceStatusCode || ''
// if (deviceStatusCode) {
//   formInline.value.deviceStatusCode = deviceStatusCode
// }

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await devicePage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    siteId: props.siteId,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const toDetail = ({ deviceId }: any) => {
  router.push({
    name: 'device-data',
    query: {
      deviceId,
    },
  })
}

const deviceCheck = async (deviceId: string) => {
  const res: any = await deviceOnlinecheck({
    deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessageBox.alert(t('D_INFO.commondTip'), t('D_INFO.commondTitle'), {
      autofocus: false,
      confirmButtonText: t('D_INFO.btnYes'),
      callback: () => {},
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('SITE.associatedDevices')), 1),
    _createVNode(_unref(AdvancedQueryLayout), {
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList,
      "label-width": 92,
      class: "search-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.deviceName'),
          prop: "deviceId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.deviceId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.deviceId) = $event)),
              filterable: "",
              placeholder: _ctx.$t('D_INFO.deviceNamePla'),
              class: "ws_select",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceStore).deviceOps, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.deviceSn'),
          prop: "deviceSn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.deviceSn,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.deviceSn) = $event)),
              clearable: "",
              maxlength: "50",
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.productType'),
          prop: "productKey"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.productKey,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.productKey) = $event)),
              clearable: "",
              class: "ws_select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).productGetewayType, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.code,
                    label: item.name,
                    value: item.code
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.deviceStatusCode'),
          prop: "deviceStatusCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.deviceStatusCode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInline.value.deviceStatusCode) = $event)),
              filterable: "",
              placeholder: _ctx.$t('D_INFO.deviceStatusCodePla'),
              class: "ws_select",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(deviceStatusOps, (item) => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      stripe: "",
      class: "ws_mt30 ws_common_table"
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_el_empty, {
          description: _ctx.$t('D_INFO.noData')
        }, null, 8, ["description"])
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
          return _createVNode(_component_el_table_column, _mergeProps({
            key: item.prop
          }, {
          ...item,
        }, { "show-overflow-tooltip": "" }), null, 16)
        }), 64)),
        _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "",
          prop: "deviceAddress",
          label: _ctx.$t('D_INFO.colAddress')
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(get)(scope.row, 'deviceLocationInfo.deviceAddress')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          width: "140",
          prop: "deviceStatusName",
          label: _ctx.$t('D_INFO.deviceStatusName')
        }, {
          default: _withCtx((scope) => [
            (scope.row.deviceStatusCode)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  class: "ml-2",
                  type: getDeviceTagType(scope.row.deviceStatusCode)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.deviceStatusName), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]))
              : _createCommentVNode("", true),
            (
            scope.row.deviceStatusCode === _unref(DEVICE_STATUS_ENUM).OFFLINE &&
            scope.row.supportOnlineMethod
          )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: ($event: any) => (deviceCheck(scope.row.deviceId)),
                  class: "ws_ml15 online-check"
                }, _toDisplayString(_ctx.$t('D_INFO.onlineCheck')), 9, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "createDate",
          label: _ctx.$t('D_INFO.colCreateTime'),
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(moment)(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "operation",
          label: _ctx.$t('D_INFO.colOperation'),
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(OperationButtonList), {
              buttonList: buttonList.value,
              scope: scope.row,
              onOnDetail: toDetail
            }, null, 8, ["buttonList", "scope"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      class: "ws_mt50",
      "current-page": pageParams.value.curPage,
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.curPage) = $event)),
      "page-size": pageParams.value.pageSize,
      "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageParams.value.pageSize) = $event)),
      "page-sizes": _unref(PAGE_SIZES),
      layout: "->, total, sizes, prev, pager, next, jumper ",
      total: total.value,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
  ]))
}
}

})